
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/upcoming",
      function () {
        return require("private-next-pages/sports/ipl/upcoming/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/upcoming"])
      });
    }
  